import StatusLabel from "~/components/StatusLabel";
import {Pagination, Table} from "antd";
import CustomerAction from "./CustomerAction";
import _ from "lodash";
import {renderDate} from "~/utils";
import {useUtilities} from "~/hooks";
import {Fragment, useContext} from "react";
import {AppContext} from "~/context/AppProvider";


function CustomerTable({items = [], pagination, onPaginationChange, setItemEdit, openModal, handleStatus, can}) {

	const {tableHeight} = useContext(AppContext);

	const {utilities} = useUtilities();

	const renderFor = (ufor) => {

		if(ufor === 'canhan') {
			return <StatusLabel small type="green">Cá nhân</StatusLabel>
		}
		if(ufor === 'congty') {
			return <StatusLabel small type="blue">Công ty</StatusLabel>
		}

		return <StatusLabel small type="green">Không xác định</StatusLabel>
	}

	const renderGroups = (groups) => {
		if(!_.isEmpty(groups)) {
			return (
				<Fragment>
					{
						Object.entries(groups).map(([key, value]) => {
							return <StatusLabel small type={value.badge}>{value.name}</StatusLabel>
						})
					}
				</Fragment>
			)
		}
		else {
			return '';
		}
	}

	let columns = [
		{ title: 'Mã KH', dataIndex: 'code', key: "code", width: '100px', render: (_, item) => (
			<div>
				<b>{item?.code}</b>
				<p>{renderFor(item?.for)}</p>
			</div>
		)},
		{ title: 'Khách hàng', dataIndex: 'name', key: "name", width: '200px', render: (_, item) => (
			<div>
				<b style={{color : 'var(--primary)'}}>{item.companyName}</b>
				<p><b>{item.name}</b></p>
				{item.user?.id && <p>{`${item.user?.firstname} ${item.user?.lastname}`}</p>}
				{item.userShare?.id && <p>{`${item.userShare?.firstname} ${item.userShare?.lastname}`}</p>}
				{item.marketingUser?.id && <p style={{color : 'var(--cyan)'}}>{`MKT: ${item.marketingUser?.firstname} ${item.marketingUser?.lastname}`}</p>}
				{item.marketingUserShare?.id && <p style={{color : 'var(--cyan)'}}>{`MKT: ${item.marketingUserShare?.firstname} ${item.marketingUserShare?.lastname}`}</p>}
			</div>
		)},
		{ title: 'Liên hệ', dataIndex: 'contact', key: "contact", width: '200px', render: (_, item) => (
			<div>
				<p>{item?.phone}</p>
				<p>{item?.email}</p>
			</div>
		)},
		{ title: 'Nhóm', dataIndex: 'groups', key: "groups", width: '200px', render: (_, item) => (renderGroups(item?.groups))},
		{ title: 'Dịch vụ', dataIndex: 'serviceCount', key: "serviceCount", width: '100px', render: (_, item) => (
			<div><p>{item?.services?.length}</p></div>
		)},
		{ title: 'Trạng thái', dataIndex: 'status', key: "status", width: '140px', render: (_, item) => (
			<p><StatusLabel small type={item.status.badge}>{item.status.label}</StatusLabel></p>
		)},
		{ title: '#', dataIndex: 'action', key: "action", width: '150px', render: (_, item) => (
			<CustomerAction key={item.id}
							item={item}
							setItemEdit={setItemEdit}
							openModal={openModal}
							handleStatus={handleStatus}
							can={can}
			/>
		)},
	];

	if(!can.groups) {
		columns = columns.filter(function (currentValue) {
			return (currentValue.key !== 'groups')
		})
	}

	if(!can.infoContact) {
		columns = columns.filter(function (currentValue) {
			return (currentValue.key != 'contact')
		})
	}

	const dataSource= items.map(row => ({
		key: row.id, // I added this line
		...row
	}));

	const expandedRowRender = (record) => {
		let columns = [
			{title: 'Tên miền', dataIndex: 'domain', key: 'domain'},
			{title: 'Dịch vụ', dataIndex: 'service', key: 'service', render:(_, item) => (<StatusLabel small type={item.service?.badge}>{item.service?.label}</StatusLabel>)},
			{title: 'Gói dịch vụ', dataIndex: 'package', key: 'package', render:(_, item) => (
				<StatusLabel small type={item.service?.badge}>{item?.package}</StatusLabel>
			)},
			{title: 'Ngày ký', dataIndex: 'register', key: "register", responsive: ['lg'], render: (_, item) => (renderDate(item?.register)) },
			{title: 'Ngày hết hạn', dataIndex: 'expired', key: "expired", responsive: ['lg'], render: (_, item) => (renderDate(item?.expired)) },
		];

		if(!can.extend) {
			columns = columns.filter(function (currentValue) {
				return (currentValue.key != 'register'
					&& currentValue.key != 'expired'
				)
			})
		}

		const dataSource= record.services.map(row => ({
			key: row.id, // I added this line
			...row
		}));

		return <Table columns={columns} dataSource={dataSource} pagination={false} />;
	};

	return (
		<div className="table-wrapper">
			<div className="table-box">
				<Table
					columns={columns} dataSource={dataSource} scroll={{ y:tableHeight, x: 'max-content' }} pagination={false}
					expandable={{expandedRowRender: expandedRowRender,}}
				/>
			</div>
			<Pagination current={pagination.page} defaultCurrent={1} defaultPageSize={20} pageSize={pagination.limit} total={pagination.total} onChange={onPaginationChange}  showSizeChanger={false} />
		</div>
	)
}

export default CustomerTable;